<style lang="less" scoped>
  .do-appraise-wrapper {
    position: relative;
    height: 100%;
    overflow: hidden;
    .do-appraise-content {
      max-height: 100%;
      min-height: 90%;
      padding-bottom: 100rpx;
      background: #fff;
      overflow: hidden auto;
    }
    .appraise-merchant {
      display: flex;
      align-items: center;
      height: 104rpx;
      padding: 0 30rpx;
      font-size: 1.2rem;
      font-weight: 500;
      color: #333;
      line-height: 1;
      box-shadow: 0 0 1px 1px #ebebeb;
    }
    .auth-icon {
      height: 1.5em;
      margin-right: 0.6em;
    }
    .merchant-name {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      line-height: 1.5;
      text-overflow: ellipsis;
    }
    .appraise-score {
      padding: 100rpx 0 60rpx;
      text-align: center;
    }
    .appraise-score-title {
      margin-bottom: 30rpx;
      color: #999;
      line-height: 1;
    }
    .appraise-tag {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin: 0 14rpx 0 30rpx;
    }
    .appraise-tag-btn {
      flex: 0 0 auto;
      height: 60rpx;
      padding: 0 24rpx;
      margin-right: 16rpx;
      margin-bottom: 34rpx;
      color: #929292;
      background: #fff;
      border: 1px solid #dadada;
      border-radius: 4rpx;
      outline: none;
      transition: color 0.2s ease, border-color 0.2s ease,
        background-color 0.2s ease;

      &:active,
      &.active {
        color: #ffad0b;
        border-color: #ffad0b;
        background: #ffecc7;
      }
    }
    .appraise-describe {
      padding-bottom: 30rpx;
      margin: 0 30rpx 0;
      border: 1px solid #eae8e8;
    }
    .appraise-describe-text {
      width: 100%;
      height: 230rpx;
      padding: 20rpx 30rpx 20rpx;
      font-size: 0.9rem;
      color: #333;
      line-height: 1.5;
      border: 0;
      box-sizing: border-box;
      resize: none;
      outline: none;
    }
    .do-appraise-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      display: block;
      width: 100%;
      background: #fff;
      z-index: 10;
      ._btn {
        display: block;
        width: 100%;
        height: 100rpx;
        color: #fff;
        background: @DefaultColor;
        cursor: pointer;
        outline: none;
        border: 0;
        transition: opacity 0.2s ease, background-color 0.2s ease;
        &:active {
          opacity: 0.8;
        }
        &[disabled] {
          background: #e2e2e2;
          cursor: not-allowed;
        }
      }
    }
  }
</style>
<style lang="less">
  .do-appraise-wrapper {
    .appraise-describe-file {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      padding: 0 30rpx 0;
    }
    .van-uploader {
      flex: 0 0 auto;
      width: 152rpx;
      height: 152rpx;
      margin: 0 0 20rpx 0;
    }
    .van-uploader__input-wrapper {
      position: relative;
      width: 152rpx;
      height: 152rpx;
      background: #fff;
      border: 1px dashed #999;
    }

    .van-uploader__preview-item {
      position: relative;
      width: 152rpx;
      height: 152rpx;
      margin: 0 20rpx 20rpx 0;
    }
    .van-uploader__preview-img {
      display: block;
      max-width: 100%;
      max-height: 100%;
      margin: 0 auto;
    }
    .van-uploader__preview-remove {
      position: absolute;
      top: 0;
      right: 0;
      width: 40rpx;
      height: 40rpx;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 40rpx;
      font-size: 12px;
      font-weight: 900;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translate(30%, -30%);
    }
    .van-uploader__icon {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 64rpx;
      height: 52rpx;
      transform: translate(-50%, -50%);
    }
    .van-uploader__loading {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      color: #ff585a;
      background: rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
    }
  }
</style>
<template>
  <div class="safe-area-bottom do-appraise-wrapper">
    <div class="do-appraise-content">
      <div class="appraise-merchant">
        <img class="auth-icon"
             src="~@/assets/icon_warranty_order_list_store.png">
        <span class="merchant-name">商家：{{ storeName }}</span>
      </div>
      <div class="appraise-score">
        <div class="appraise-score-title">为服务打分</div>
        <van-rate v-model="evaluateStar"
                  count="5"
                  gutter="8"
                  allow-half
                  :size="36"
                  color="#fea032"
                  void-icon="star" />
      </div>

      <!-- 标签 -->
      <div class="appraise-tag">
        <button v-for="(tag, index) in tags"
                :key="index"
                @click="tagsEvent(tag)"
                :class="{active: tagSelected.includes(tag.id)}"
                class="appraise-tag-btn">{{ tag.preinstallEvaluate }}</button>
      </div>

      <div class="appraise-describe">
        <textarea v-model="evaluateRemark"
                  class="appraise-describe-text"
                  cols="30"
                  rows="10"
                  placeholder="请输入您的评价~"></textarea>
        <div class="appraise-describe-file">
          <div class="van-uploader__preview-item"
               v-for="(pre, index) in imgPreviewList"
               @click="ImagePreviewFn(index)"
               :key="index">
            <img :src="pre"
                 class="van-uploader__preview-img">
            <span class="van-uploader__preview-remove"
                  @click.stop="removeFromList(index)">
              <van-icon size="1em"
                        color="#fff"
                        name="cross" />
            </span>
          </div>
          <van-uploader :preview-image="false"
                        accept="image/*"
                        :max-size="imgSize * 1024 * 1024"
                        result-type="file"
                        :multiple="false"
                        upload-text="添加图片"
                        :before-read="handleFileBeforeRead"
                        :after-read="handleFileAfterRead"
                        preview-size="16vw"
                        :max-count="5">
            <img class="van-uploader__icon"
                 src="~@/assets/icon_uploader.png">
            <van-loading v-show="uploading"
                         class="van-uploader__loading"
                         :size="28" />
          </van-uploader>
        </div>
      </div>
    </div>
    <div class="safe-area-bottom do-appraise-btn">
      <button class="_btn"
              @click="submitFn"
              :disabled="!evaluateStar">提交评价</button>
    </div>

  </div>
</template>
<script>
  import photoCompress from '@/util/photo-compress.js'
  import { appraiseOrder, queryAppraiseTags, uploadImages } from '@/config/api.js'

  export default {
    name: 'DoAppraise',
    data () {
      return {
        uploading: false,
        imgSize: 10,
        evaluateStar: 0,
        imgPreviewList: [],
        tags: [],
        tagSelected: [],
        evaluateRemark: '',
        storeName: ''
      }
    },
    methods: {
      tagsEvent (data) {
        const exist = this.tagSelected.includes(data.id)
        if (!exist) {
          this.tagSelected.push(data.id)
        } else {
          const index = this.tagSelected.indexOf(data.id)
          this.tagSelected.splice(index, 1)
        }
      },
      ImagePreviewFn (index) {
        const _list = [].concat(this.imgPreviewList)
        this.$imagePreview({
          images: _list,
          startPosition: index,
          closeable: true
        })
      },
      removeFromList (index) {
        this.imgPreviewList.splice(index, 1)
      },
      handleFileBeforeRead (file, detail) {
        if (/^image\/(jpg|jpeg|png)$/i.test(file.type) === false) {
          this.$toast('请选择JPG、PNG格式的图片')
          return false
        }
        if (file.size > this.imgSize * 1024 * 1024) {
          this.$toast(`图片大小不能超过 ${this.imgSize} M`)
          return false
        }
        this.uploading = true
        return true
      },
      handleFileAfterRead (file, detail) {
        const imgType = file.file.type.replace('image/', '')

        photoCompress(file.file, { minSize: 100, format: imgType }).then(res => {
          if (res.success) {
            const formData = new FormData()
            formData.append('file', res.result.file)
            uploadImages(formData).then(response => {
              this.uploading = false
              if (response.success) {
                this.imgPreviewList.splice(0, 0, response.result)
              }
            })
          } else {
            this.$toast(res.message)
          }
        })
      },
      dialogBeforeClose (action, done) {
        if (action === 'confirm') {
          const params = {
            evaluateImgList: [], // 评价图片
            evaluateRemark: this.evaluateRemark || '', // 评价内容
            evaluateStar: this.evaluateStar, // 评分
            orderCode: this.$route.query.key,
            orderId: this.$route.query.id,
            storeOrderEvaluatePreinstallList: [] // 服务标签
          }

          this.imgPreviewList.forEach(item => {
            params.evaluateImgList.push({
              imgPath: item
            })
          })

          this.tagSelected.forEach(item => {
            this.tags.forEach(tag => {
              if (item === tag.id) {
                params.storeOrderEvaluatePreinstallList.push({
                  delFlag: tag.delFlag,
                  id: tag.id,
                  preinstallEvaluate: tag.preinstallEvaluate,
                  type: tag.type
                })
              }
            })
          })
          appraiseOrder(params).then(res => {
            done && done()
            if (res.success) {
              this.$toast('您的评价已提交，谢谢参与！')
              this.$router.replace({
                path: '/evaluate-detail',
                query: {
                  usr: this.$route.query.usr,
                  key: this.$route.query.key,
                  id: this.$route.query.id
                }
              })
            }
          })
        } else {
          done && done()
        }
      },
      submitFn () {
        const that = this
        let message = []
        if (!this.tagSelected.length) {
          message.push('- 为服务打标签')
        }
        if (!this.imgPreviewList.length) {
          message.push('- 秀几张商品图')
        }
        if (!this.evaluateRemark) {
          message.push('- 给我们点批评或赞美')
        }

        if (message.length) {
          this.$dialog.confirm({
            width: '80%',
            title: '请君留步～',
            message: `我们其实还可以做更多的事，比如：\n${message.join('\n')}`,
            messageAlign: 'left',
            confirmButtonText: '执意提交',
            confirmButtonColor: that.sysConstConfig.themeConfig.DefaultColor,
            cancelButtonText: '完善评价',
            cancelButtonColor: '#999',
            beforeClose: that.dialogBeforeClose
          })
        } else {
          this.dialogBeforeClose('confirm')
        }
      }
    },
    mounted () {
      this.storeName = this.$route.query.store
      queryAppraiseTags().then(res => {
        if (res.success) {
          this.tags = []
          const list = res.result || []
          list.forEach(item => {
            this.tags.push({
              delFlag: item.delFlag,
              id: item.id,
              preinstallEvaluate: item.preinstallEvaluate,
              type: item.type
            })
          })
        }
      })
    }
  }
</script>